<template>
    <div>
        <div
            class="flex flex-row  w-full items-center align-baseline transition-all ease-in-out duration-1000"
            :class="{ 'opacity-50' : disabled , 'bg-blue-20 shadow-3dp' : isSelecting }"
        >
            <product-field-info
                :field="field"
                :isSelecting="isSelecting"
                :selected="selected"
                :selectedDisplayName="formatSelectedName"
                :position="position"
                :total="total"
                :isMobileView="isMobileView"
                :showDescription="showSideBarDescription"
                @ShowLearMore="ShowLearMore"
                @HideLearMore="HideLearMore"
            />

            <div class="hidden lg:block w-full py-4 order-3 mr-2 | md:order-2 md:w-auto md:flex-1">
                <select
                    class="block w-full cursor-pointer border-2 border-blue shadow-sm text-sm bg-gray text-darkblue-800 py-2 px-4 pr-8  focus:border-gray-500"
                    :value="mobileSelectOption ? mobileSelectOption : selectedIndex"
                    @change="changed"
                    @click="clearSelected"
                    :disabled="disabled"
                    placehoolder="Select an option"
                >
                    <option disabled hidden :value="null">Select an option</option>
                    <option
                        v-for="(field,index) in getVisibleFields(field.options)"
                        :value="index"
                        :key="`field-options-${index}`"
                    >{{ field.label }} - £{{ field.getPricePerType() }} {{ field.getTypeLabel() }}
                    </option>
                </select>

                <div
                    class="pt-4 transition-all duration-500 overflow-hidden"
                    :class="{'h-full' : isSelecting , 'h-0' : !isSelecting}"
                >
                    <h6 class="text-h6 my-2">Bespoke bevel size specification</h6>

                    <p class="text-4 my-2">State Width of Bevel - Max 15mm Bevel for 3mm and 20mm Bevel for 4mm</p>

                    <textarea v-model="comment" class="w-full p-4" rows="4" placeholder="Write in here..."></textarea>
                    
                    <div
                        class="flex"
                        :class="{ 'text-white': mobileSelectOption !== null, 'text-black' : mobileSelectOption === null  }"
                    >
                        <button
                            class=" w-full text-1--inherit p-[11px] font-bold text-center cursor-pointer"
                            :class="{ 'bg-darkblue': mobileSelectOption !== null, 'bg-darkblue-200' : mobileSelectOption === null  }"
                            :disabled="mobileSelectOption === null"
                            @click="selectOption(mobileSelectOption)"
                        >
                            Confirm
                        </button>
                    </div>
                    
                </div>

            </div>

            <div class="flex flex-col items-end w-full mr-[20px]  lg:hidden">
                <div class="">
                    <div
                        v-if="hasDescriptions"
                        class="flex items-center mx-2 text-sm cursor-pointer text-blue-500 underline"
                        @click="ShowLearMore"
                    >
                        <icon-info class="h-4 mr-1"/>
                        Learn More
                    </div>
                </div>

                <div class="">
                    <select-button :clicked="showMobileSelect" :selected="selected"></select-button>
                </div>
            </div>

            <MountingPortal append mountTo="#configurator-field-menu" multiple>
                <MobileSelect
                    :show="mobileSelect" @close="hideMobileSelect"
                    :title="field.label + ' options'"
                >
                    <div class="flex flex-col items-stretch pt-[10px] overflow-y-auto h-[calc(100%-140px)]">
                        <div
                            v-for="(field,index) in getVisibleFields(field.options)"
                            class="px-[20px] py-[10px] cursor-pointer "
                            :class="{ 'bg-blue text-white' : mobileSelectOption === index }"
                            @click="selectMobileOption(index)"
                        >{{ field.label }}
                        </div>

                        <div class="px-6 pb-2 mt-4">
                            <h6 class="text-h6 my-2">Bespoke bevel size specification</h6>

                            <p class="text-4 my-2">State Width of Bevel - Max 15mm Bevel for 3mm and 20mm Bevel for 4mm</p>

                            <textarea
                                v-model="comment"
                                class="w-full p-4 border border-darkblue-200"
                                rows="4"
                                placeholder="Write in here..."
                            ></textarea>
                        </div>
                    </div>

                    <div
                        class="flex p-[20px]  "
                        :class="{ 'text-white': mobileSelectOption !== null, 'text-black' : mobileSelectOption === null  }"
                    >
                        <button
                            class=" w-full text-1--inherit p-[11px] font-bold text-center cursor-pointer"
                            :class="{ 'bg-darkblue': mobileSelectOption !== null, 'bg-darkblue-200' : mobileSelectOption === null  }"
                            :disabled="mobileSelectOption === null"
                            @click="selectOption(mobileSelectOption)"
                        >
                            Confirm
                        </button>
                    </div>

                </MobileSelect>
            </MountingPortal>

        </div>
    </div>
</template>

<script>
import IconInfo from "../Icons/IconInfo";
import ProductFieldInfo from "../helpers/ProductFieldInfo";
import SelectButton from "../helpers/SelectButton";
import MobileSelect from "../MobileSelect";

export default {
    name: "ProductFieldAndComment",
    components: {
        MobileSelect,
        SelectButton,
        ProductFieldInfo,
        IconInfo
    },
    props: {
        field: {},
        sizes: {},
        total: 0,
        position: 0,
        fieldDisplayPrice: 0,
        showMinPrice: {
            default: false,
        },
        selected: {
            default: null
        },
        disabled: {
            default: true
        },
        fieldUpdated: {
            type: Function,
            default: () => {}
        },
        conditionController: {}
    },
    created() {
        this.onResize();
        this.initOption()
        window.addEventListener("resize", this.onResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },
    data() {
        return {
            mobileSelect: false,
            mobileSelectOption: null,
            showSideBarDescription: false,
            selecting: this.selected,
            selectedIndex: null,
            innerWidth: window.innerWidth,
            isMobileView: false,
            comment: '',
        }
    },
    watch: {
        selected(newValue) {
            if (!newValue) {
                this.selectedIndex = null
            }
        }
    },
    computed: {
        canBeEdited() {
            return this.field.selectedOption !== null || this.isSelecting
        },
        isSelecting() {
            return this.showDescription;
        },
        showDescription() {
            return !this.disabled && !this.field.selectedOption
        },
        showSelect() {
            return !this.field.selectedOption || this.edit
        },
        selectedPrice() {

            if (!this.selected) {
                return ''
            }

            if (!this.showMinPrice) {
                return '';
            }

            if (this.fieldDisplayPrice <= 0) {
                return false;
            }

            return this.fieldDisplayPrice;//PriceCalculator.roundUp(this.selected.getPrice(this.sizes), 2).toFixed(2)
        },
        hasDescriptions() {
            return this.field.options?.filter(item => {
                return item.description.text !== '';
            }).length ?? false;
        },
        formatSelectedName() {
            return this.selected?.label ?? '';
        }
    },
    methods: {
        initOption() {
            const selected = this.field.selected
            
            const fields = this.getVisibleFields(this.field.options)
            
            const indexSelected = fields.find( (field, index) => {
                if(field === selected){
                    return index;
                }
            });
            
            if(indexSelected){
                this.selectedIndex = indexSelected;
            }
            
        },
        selectMobileOption(index) {
            this.mobileSelectOption = index
        },
        showMobileSelect() {
            if (this.canBeEdited) {
                this.mobileSelect = true;
                this.mobileSelectOption = null;
            }
        },
        hideMobileSelect() {
            this.mobileSelect = false;
            this.mobileSelectOption = null;
        },
        ShowLearMore() {
            this.showSideBarDescription = true;
        },
        HideLearMore() {
            this.showSideBarDescription = false;
        },
        changed(e) {
            e?.target ? this.selectMobileOption(e.target.value) : null;
        },
        clearSelected() {
            this.field.selectedOption = false;
        },
        selectOption(index) {
            this.field.selectedOption = this.getVisibleFields(this.field.options)[index];

            this.selectedIndex = index;
            // this.mobileSelectOption = null;
            this.hideMobileSelect()

            this.field.mapToForm = this.mapToForm();
            this.fieldUpdated();
        },
        getVisibleFields(fields) {
            return fields.filter(field => {
                return this.conditionController.isFieldOptionShouldBeDisplayed(field);
            });
        },
        editField() {
            this.selecting = null;
            this.field.selectedOption = false;
            this.field.mapToForm = this.mapToForm();
        },
        mapToForm() {
            return [
                {
                    id: this.field.id,
                    name: this.field.name,
                    label: this.field.label,
                    selected: this.field.selectedOption,
                },
                {
                    id: "edge_com",
                    label: "Edging Info",
                    name: "Edging Info",
                    selected: {
                        name: this.comment ?? '',
                    }
                }
            ]

        },
        onResize(e) {
            this.innerWidth = window.innerWidth

            this.isMobileView = this.innerWidth <= 1024;
        }
    },
}
</script>